<template>
  <div
    class="text-image section"
    :style="sectionStyle"
  >
    <div class="container flex">
      <div v-if="photoUrl">
        <q-img
          :src="photoUrl"
          :width="`${photoWidth}px`"
        />
      </div>
      <div class="col">
        <div
          v-if="title"
          class="title q-mb-md"
          :style="titleStyle"
          v-html="$options.filters.pureHtml(title)"
        />
        <div
          v-if="description"
          :style="descriptionStyle"
          v-html="$options.filters.pureHtml(description)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import photoMixin from './mixins/photoMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'TextImageSection',
  mixins: [
    backgroundMixin,
    descriptionMixin,
    photoMixin,
    titleMixin,
  ],
};
</script>
